module.exports = __webpack_public_path__ + "img/admin-primary.94132959.svg";